export enum Keyboard {
    ENTER = 13,
    ESC = 27,
    SHIFT = 16,
    CTRL = 17,
    ALT= 18,
    LEFT= 37,
    UP= 38,
    RIGHT= 39,
    DOWN= 40,
    BACKSPACE= 8,
    SPACE= 32,
    TAB= 9
}
